function getPriceByInterval(prices, interval_id){
  let ok = Object.keys(prices)
  let okl = ok.length
  for (let i = 0; i < okl; i++) {
    if(prices[ok[i]].interval_id === interval_id) return prices[ok[i]]
  }
  return null
}

export { getPriceByInterval }